export default __webpack_public_path__ + "static/media/united-kingdom.70e4e37f.svg";